import { call, put, takeLatest } from "redux-saga/effects";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import { downloadFile } from "utils/api";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  requestSaga,
  subKeySaga,
  fillDictionary,
  handleCallback,
  makeWritePayload
} from "shared-utility/store/utils/helpers";

import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";

export const LRD_UPDATE_AUTH_RECORD = generateDefaultActions("LRD_UPDATE_AUTH_RECORD");
export const updateAuthRecord = payload => makePayload(LRD_UPDATE_AUTH_RECORD.value, payload);
function* updateAuthRecordSaga({ rgiId, expirationDate }) {
  const url = `/lrd/report/${rgiId}/auth`;
  yield requestSaga(LRD_UPDATE_AUTH_RECORD, url, "POST", { expirationDate });
}

export const LRD_MARK_AUTH_EMAIL = generateDefaultActions("LRD_MARK_AUTH_EMAIL");
export const markAuthEmail = payload => makePayload(LRD_MARK_AUTH_EMAIL.value, payload);
function* markAuthEmailSaga({ rgiId }) {
  const url = `/lrd/report/${rgiId}/auth/email`;
  yield requestSaga(LRD_MARK_AUTH_EMAIL, url, "POST", {});
}

export const LRD_MARK_AUTH_EXTERNAL = generateDefaultActions("LRD_MARK_AUTH_EXTERNAL");
export const markAuthExternal = payload => makePayload(LRD_MARK_AUTH_EXTERNAL.value, payload);
function* markAuthExternalSaga({ rgiId }) {
  const url = `/lrd/report/${rgiId}/auth/external`;
  yield requestSaga(LRD_MARK_AUTH_EXTERNAL, url, "POST", {});
}

export const LRD_DOWNLOAD_REPORT = generateDefaultActions("LRD_DOWNLOAD_REPORT");
export const downloadReport = payload => makePayload(LRD_DOWNLOAD_REPORT.value, payload);
function* downloadReportSaga({ rgiId }) {
  const url = `lrd/report/${rgiId}/download`;
  try {
    const response = yield call(downloadFile, url, "GET", {});
    yield put(LRD_DOWNLOAD_REPORT.createSuccess(response));
  } catch (error) {
    yield put(LRD_DOWNLOAD_REPORT.createFailure(error));
  }
}

export const LRD_LENDER_DOWNLOAD_REPORT = generateDefaultActions("LRD_LENDER_DOWNLOAD_REPORT");
export const downloadLenderReport = payload => makePayload(LRD_LENDER_DOWNLOAD_REPORT.value, payload);
function* downloadLenderReportSaga({ rgiId, pin, reportFiles = "", moduleFiles = null, taskName = null }) {
  const url = `lrd/report/${rgiId}/lender/download?authCode=${pin}`;
  const body = {
    reportFiles: reportFiles ? JSON.parse(reportFiles) : [],
    moduleFiles,
    taskName
  };
  try {
    const response = yield call(downloadFile, url, "POST", body);
    yield put(LRD_LENDER_DOWNLOAD_REPORT.createSuccess(response));
  } catch (error) {
    yield put(LRD_LENDER_DOWNLOAD_REPORT.createFailure(error));
  }
}

export const LRD_GET_REPORT_GROUPS = generateDefaultActions("LRD_GET_REPORT_GROUPS");
export const getReportGroups = payload => makePayload(LRD_GET_REPORT_GROUPS.value, payload);
function* getReportGroupsSaga() {
  const url = "/lrd/getReportGroups";
  yield requestSaga(LRD_GET_REPORT_GROUPS, url, "GET");
}

export const LRD_GET_RECIPIENTS_CONFIG = generateDefaultActions("LRD_GET_RECIPIENTS_CONFIG");
export const getRecipientsConfig = (payload) => makePayload(LRD_GET_RECIPIENTS_CONFIG.value, payload);
function* getRecipientsConfigSaga({ loanId, companyId }) {
  const url = `/lrd/shares/config/${loanId}/${companyId}`;
  yield requestSaga(LRD_GET_RECIPIENTS_CONFIG, url, "GET");
}

export const LRD_UPDATE_RECIPIENTS_CONFIG = generateDefaultActions("LRD_UPDATE_RECIPIENTS_CONFIG");
export const updateRecipientsConfig = (payload) => makePayload(LRD_UPDATE_RECIPIENTS_CONFIG.value, payload);
function* updateRecipientsConfigSaga(payload) {
  const url = "/lrd/shares/config";
  yield requestSaga(LRD_UPDATE_RECIPIENTS_CONFIG, url, "POST", payload);
}

export const LRD_GET_SHARE_RECORDS = generateDefaultActions("LRD_GET_SHARE_RECORDS");
export const getShareRecords = (payload) => makePayload(LRD_GET_SHARE_RECORDS.value, payload);
function* getShareRecordsSaga({ rgiId }) {
  const url = `/lrd/shares/${rgiId}`;
  yield requestSaga(LRD_GET_SHARE_RECORDS, url, "GET");
}

export const LRD_CREATE_SHARE_RECORD = generateDefaultActions("LRD_CREATE_SHARE_RECORD");
export const createShareRecord = (payload) => makePayload(LRD_CREATE_SHARE_RECORD.value, payload);
function* createShareRecordSaga(payload) {
  const url = "/lrd/shares";
  yield requestSaga(LRD_CREATE_SHARE_RECORD, url, "POST", payload);
}

export const LRD_CREATE_SHARE_RECORDS = generateDefaultActions("LRD_CREATE_SHARE_RECORDS");
export const createShareRecords = (payload) => makePayload(LRD_CREATE_SHARE_RECORDS.value, payload);
function* createShareRecordsSaga(payload) {
  const url = "/lrd/shares-batch";
  yield requestSaga(LRD_CREATE_SHARE_RECORDS, url, "POST", payload);
}

export const LRD_UPDATE_SHARE_RECORDS = generateDefaultActions("LRD_UPDATE_SHARE_RECORDS");
export const updateShareRecords = payload => makePayload(LRD_UPDATE_SHARE_RECORDS.value, payload);
function* updateShareRecordsSaga({ rgiId, unshared }) {
  const url = `/lrd/shares/update/${rgiId}`;
  yield requestSaga(LRD_UPDATE_SHARE_RECORDS, url, "POST", { unshared });
}

export const LRD_GET_SUBMITTED_RGIS = generateDefaultActions("LRD_GET_SUBMITTED_RGIS");
export const getSubmittedRgis = payload => makePayload(LRD_GET_SUBMITTED_RGIS.value, payload);
function* getSubmittedRgisSaga({ reportGroupId }) {
  const url = `/lrd/getSubmittedReportsByReportGroupId/${reportGroupId}`;
  yield requestSaga(LRD_GET_SUBMITTED_RGIS, url, "GET");
}

export const LRD_GET_LENDER_VIEW_REPORT = generateDefaultActions("LRD_GET_LENDER_VIEW_REPORT");
export const getLenderViewReport = payload => makePayload(LRD_GET_LENDER_VIEW_REPORT.value, payload);
function* getLenderViewReportSaga({ reportId, pin }) {
  const url = `/lrd/report/${reportId}/lender?authCode=${pin || ""}`;
  yield requestSaga(LRD_GET_LENDER_VIEW_REPORT, url, "GET");
}
export const LRD_GET_CONFIG_ITEMS = generateDefaultActions("LRD_GET_CONFIG_ITEMS");
export const getReportingConfigItems = payload => makePayload(LRD_GET_CONFIG_ITEMS.value, payload);
function* getReportingConfigItemsSaga({ reportId }) {
  const url = `/lrd/configItems/${reportId}`;
  yield requestSaga(LRD_GET_CONFIG_ITEMS, url, "GET");
}
export const LRD_GET_INSTANCE_DETAILS = generateDefaultActions("LRD_GET_INSTANCE_DETAILS");
export const getInstanceDetails = payload => makePayload(LRD_GET_INSTANCE_DETAILS.value, payload);
function* getInstanceDetailsSaga({ reportId }) {
  const url = `/lrd/getInstanceDetails/${reportId}`;
  yield requestSaga(LRD_GET_INSTANCE_DETAILS, url, "GET");
}
export const LRD_UPDATE_INSTANCE_DETAILS = generateDefaultActions("LRD_UPDATE_INSTANCE_DETAILS");
export const updateInstanceDetails = payload => makePayload(LRD_UPDATE_INSTANCE_DETAILS.value, payload);
function* updateInstanceDetailsSaga({ reportId, reportGroupInstance }) {
  const url = `/report-groups/instances`;
  yield requestSaga(LRD_UPDATE_INSTANCE_DETAILS, url, "PUT", reportGroupInstance, null, false, true);
  yield put(getInstanceDetails({ reportId }));
}
export const LRD_DELETE_REPORT_GROUP_INSTANCE = generateDefaultActions("LRD_DELETE_REPORT_GROUP_INSTANCE");
export const deleteReportGroupInstance = payload => makePayload(LRD_DELETE_REPORT_GROUP_INSTANCE.value, payload);
export const deleteReportGroupInstanceSaga = function* ({ reportGroupInstanceId, resolve, reject }) {
  const url = `/lrd/${reportGroupInstanceId}`;
  const result = yield requestSaga(LRD_DELETE_REPORT_GROUP_INSTANCE, url, "DELETE");

  if (result.error) {
    reject();
  } else {
    resolve();
  }
};
export const LRD_UPDATE_TASKS = generateDefaultActions("LRD_UPDATE_TASKS");
export const updateTasks = payload => makePayload(LRD_UPDATE_TASKS.value, payload);

function* updateTasksSaga(payload) {
  const url = "/lrd/updateTasks";
  yield requestSaga(LRD_UPDATE_TASKS, url, "POST", payload);
}

export const LRD_ADD_TASK = generateDefaultActions("LRD_ADD_TASK");
export const addTask = payload => makePayload(LRD_ADD_TASK.value, payload);
function* addTaskSaga(payload) {
  const url = "/lrd/addTask";
  yield requestSaga(LRD_ADD_TASK, url, "POST", payload);
}

// #region START NOTES
export const LRD_GET_NOTES = generateDefaultActions("LRD_GET_NOTES");
export const getNotes = payload => makePayload(LRD_GET_NOTES.value, payload);
function* getNotesSaga(payload) {
  const url = `/lrd/notes/${payload.taskId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(LRD_GET_NOTES, url, "GET");
}

export const LRD_PUT_NOTE = generateDefaultActions("LRD_PUT_NOTE");
export const putNote = payload => makePayload(LRD_PUT_NOTE.value, payload);
function* putNoteSaga(payload) {
  const url = `/notes/${payload.note.id}`;
  yield requestSaga(LRD_PUT_NOTE, url, "PUT", payload);
  yield put(getNotes({ taskId: payload.noteTaskId }));
}

export const LRD_POST_NOTE = generateDefaultActions("LRD_POST_NOTE");
export const postNote = payload => makePayload(LRD_POST_NOTE.value, payload);
function* postNoteSaga(payload) {
  const url = "/notes";
  const note = {
    model: "task",
    modelId: payload.noteTaskId,
    note: payload.note,
    pinned: false
  };
  yield requestSaga(LRD_POST_NOTE, url, "POST", { note });
  yield put(getNotes({ taskId: payload.noteTaskId }));
}

export const LRD_DELETE_NOTE = generateDefaultActions("LRD_DELETE_NOTE");
export const deleteNote = payload => makePayload(LRD_DELETE_NOTE.value, payload);
function* deleteNoteSaga(payload) {
  const url = `/notes/${payload.noteId}`;
  yield requestSaga(LRD_DELETE_NOTE, url, "DELETE");
  yield put(getNotes({ taskId: payload.noteTaskId }));
}
// #endregion END NOTES

// #region START ATTACHMENTS
export const LRD_GET_ATTACHMENTS = generateDefaultActions("LRD_GET_ATTACHMENTS");
export const getAttachments = payload => makePayload(LRD_GET_ATTACHMENTS.value, payload);
function* getAttachmentsSaga(payload) {
  const url = "/getFiles/byModel";
  const requestSaga = subKeySaga(payload.modelId);
  yield requestSaga(LRD_GET_ATTACHMENTS, url, "POST", payload);
}

export const LRD_PUT_ATTACHMENT = generateDefaultActions("LRD_PUT_ATTACHMENT");
export const putAttachment = payload => makePayload(LRD_PUT_ATTACHMENT.value, payload);
function* putAttachmentSaga(payload) {
  const url = "/files";
  payload = {
    ...payload,
    id: payload.fileId,
    isPrivate: payload.isPrivate,
    model: "task",
    modelId: payload.taskId,
    url: "/files",
    name: payload.name
  };
  yield requestSaga(LRD_PUT_ATTACHMENT, url, "PUT", payload);
  yield put(getAttachments({ modelName: "task", modelId: payload.taskId }));
}

export const LRD_POST_ATTACHMENT = generateDefaultActions("LRD_POST_ATTACHMENT");
export const postAttachment = payload => makePayload(LRD_POST_ATTACHMENT.value, payload);
function* postAttachmentSaga(payload) {
  const callback = handleCallback(payload);
  payload = {
    ...payload,
    model: "task",
    modelId: payload.taskId,
    url: "/files"
  };

  yield call(uploadFile, payload);
  yield put(LRD_POST_ATTACHMENT.createSuccess());
  yield put(getAttachments({ modelName: "task", modelId: payload.taskId }));
  yield callback();
}

export const LRD_DELETE_ATTACHMENT = generateDefaultActions("LRD_DELETE_ATTACHMENT");
export const deleteAttachment = payload => makePayload(LRD_DELETE_ATTACHMENT.value, payload);
function* deleteAttachmentSaga(payload) {
  const url = `/files/${payload.fileId}`;
  const callback = handleCallback(payload);

  yield requestSaga(LRD_DELETE_ATTACHMENT, url, "DELETE", payload);
  yield put(LRD_DELETE_ATTACHMENT.createSuccess());
  yield put(getAttachments({ modelName: "task", modelId: payload.taskId }));
  yield callback();
}

// #endregion END ATTACHMENTS

// #region Users Permissions and Roles
export const LRD_GET_PERMISSIONED_USER = generateDefaultActions("LRD_GET_PERMISSIONED_USER");
export const getPermissionedUser = payload => makePayload(LRD_GET_PERMISSIONED_USER.value, payload);
function* getPermissionedUserSaga({ contactId }) {
  const url = `/lrd/settings/permissionedUser/${contactId}`;
  yield requestSaga(LRD_GET_PERMISSIONED_USER, url, "GET");
}

export const LRD_GET_SETTINGS_USERS = generateDefaultActions("LRD_GET_SETTINGS_USERS");
export const getPermissionedUsers = payload => makePayload(LRD_GET_SETTINGS_USERS.value, payload);
function* getPermissionedUsersSaga({ contactIds }) {
  const formattedContactIds = contactIds?.join(",") || "";
  const url = `/lrd/settings/permissionedUsers/${formattedContactIds}`;
  yield requestSaga(LRD_GET_SETTINGS_USERS, url, "GET");
}

export const LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID = generateDefaultActions("LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID");
export const getPermissionedUserByCompanyId = payload => makePayload(LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID.value, payload);
function* getPermissionedUserByCompanyIdSaga() {
  const url = "/lrd/settings/permissionedUsersByCompany/";
  yield requestSaga(LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID, url, "GET");
}

export const LRD_UPDATE_PERMISSIONED_USERS = generateDefaultActions("LRD_UPDATE_PERMISSIONED_USERS");
export const updatePermissionedUsers = payload => makePayload(LRD_UPDATE_PERMISSIONED_USERS.value, payload);
function* updatePermissionedUsersSaga({ permissionedUsers, deletedUserIds }) {
  const url = "/lrd/settings/permissionedUsers/update";
  yield requestSaga(LRD_UPDATE_PERMISSIONED_USERS, url, "POST", { permissionedUsers, deletedUserIds });
}

// #endregion Users Permissions and Roles

export const SET_LRD_STORE = generateDefaultActions("SET_LRD_STORE");
export const setLRDStore = payload => makeWritePayload(SET_LRD_STORE.value, payload);

const initialState = {
  isReportGroupsLoading: false,
  reportGroups: [],
  reportGroupInstances: [],
  dummyData: { id: 1, name: "Dummy Data" },
  taskDetails: {},
  configItems: {},
  notes: null,
  attachments: null,
  permissionedUser: {},
  permissionedUsers: [],
  permissionedUsersByCompany: [],
  submittedRgis: [],
  isSubmittedReportsLoading: false
};

// REDUCER
export const lenderReportingDashboardReducer = function(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case LRD_DOWNLOAD_REPORT.success:
      ToastSuccess("Successfully Downloaded Report");
      return state;
    case LRD_DOWNLOAD_REPORT.failure:
      ToastError("Failed to Download Report");
      return state;
    case LRD_LENDER_DOWNLOAD_REPORT.success:
      ToastSuccess("Successfully Downloaded Lender Report");
      return state;
    case LRD_LENDER_DOWNLOAD_REPORT.failure:
      ToastError("Failed to Download Lender Report");
      return state;
    case LRD_GET_LENDER_VIEW_REPORT.success:
      return defaultReturn(state, payload.result, "lenderView");
    case LRD_GET_LENDER_VIEW_REPORT.failure:
      ToastError("Error Retrieving Reporting");

      return state;
    case LRD_GET_CONFIG_ITEMS.success:
      return defaultReturn(state, payload, "configItems");
    case LRD_GET_CONFIG_ITEMS.failure:
      ToastError("Error Retrieving Reporting");

      return state;

    case LRD_UPDATE_TASKS.success:
      ToastSuccess("Task Updated");

      return defaultReturn(state, payload, "taskDetails");
    case LRD_UPDATE_TASKS.failure:
      ToastError("Error Updating Task");

      return state;

    case LRD_UPDATE_AUTH_RECORD.success:
      ToastSuccess("Update Pin Expiration");

      return state;

    case LRD_UPDATE_AUTH_RECORD.failure:
      ToastSuccess("Failed to Update Pin Expiration");

      return state;

    case LRD_MARK_AUTH_EXTERNAL.success:
      ToastSuccess("Successfully marked as submitted");

      return defaultReturn(state, payload, "taskDetails");

    case LRD_MARK_AUTH_EXTERNAL.failure:
      ToastError("Failed to mark as submitted");

      return state;

    case LRD_GET_REPORT_GROUPS.value:
      return { ...state, isReportGroupsLoading: true };
    case LRD_GET_REPORT_GROUPS.success:
      return { ...state, isReportGroupsLoading: false, reportGroups: payload };
    case LRD_GET_REPORT_GROUPS.failure:
      ToastError("Error Retrieving Reporting");

      return { ...state, isReportGroupsLoading: false };

    case LRD_GET_SUBMITTED_RGIS.value:
      return { ...state, isSubmittedReportsLoading: true };
    case LRD_GET_SUBMITTED_RGIS.success:
      return { ...state, isSubmittedReportsLoading: false, submittedRgis: payload };
    case LRD_GET_SUBMITTED_RGIS.failure:
      ToastError("Error Retrieving Submitted Reports");

      return { ...state, isSubmittedReportsLoading: false };

    case LRD_ADD_TASK.success:
      return defaultReturn(state, payload, "taskDetails");
    case LRD_ADD_TASK.failure:
      ToastError("Error Retrieving Reporting");

      return state;

    case LRD_GET_INSTANCE_DETAILS.success:
      return defaultReturn(state, payload, "taskDetails");
    case LRD_GET_INSTANCE_DETAILS.failure:
      ToastError("Error Retrieving Reporting");

      return state;

    case LRD_DELETE_REPORT_GROUP_INSTANCE.success:
      return defaultReturn(state, {}, "taskDetails");
    case LRD_DELETE_REPORT_GROUP_INSTANCE.failure:
      ToastError("Error Deleting Report Group Instance");

      return state;

    // NOTES
    case LRD_GET_NOTES.success:
      return defaultReturn(state, payload, "notes");

    case LRD_POST_NOTE.success:
      ToastSuccess("Note Successfully Added");

      return defaultReturn(state);

    case LRD_PUT_NOTE.success:
      ToastSuccess("Note Successfully Updated");

      return defaultReturn(state);

    case LRD_DELETE_NOTE.success:
      ToastSuccess("Note Successfully Deleted");

      return defaultReturn(state);

      // SHARE HISTORY
    case LRD_GET_RECIPIENTS_CONFIG.success:
      return defaultReturn(state, payload, "recipientsConfig");

    case LRD_UPDATE_RECIPIENTS_CONFIG.success:
      return defaultReturn(state);

      case LRD_GET_SHARE_RECORDS.success:
      return defaultReturn(state, payload, "shareRecords");

    case LRD_CREATE_SHARE_RECORD.success:
      return defaultReturn(state);

    case LRD_CREATE_SHARE_RECORDS.success:
      return defaultReturn(state);

    case LRD_UPDATE_SHARE_RECORDS.success:
      return defaultReturn(state);

    // ATTACHMENTS
    case LRD_GET_ATTACHMENTS.success:
      state.taskDetails.tasks.forEach(task => {
        if (task.id === subKey) {
          task.files = payload.data;
        }
      });

      return fillDictionary(state, payload.data, "attachments", subKey);

    case LRD_PUT_ATTACHMENT.success:
      ToastSuccess("Attachment updated");

      return defaultReturn(state);

    case LRD_POST_ATTACHMENT.success:
      ToastSuccess("Attachment added");

      return defaultReturn(state);

    case LRD_POST_ATTACHMENT.failure:
      ToastSuccess("Failed to add attachment");

      return defaultReturn(state);

    case LRD_DELETE_ATTACHMENT.success:
      ToastSuccess("Attachment deleted");

      return defaultReturn(state);

    // User Roles and Permissions
    case LRD_GET_PERMISSIONED_USER.success:
      return defaultReturn(state, payload, "permissionedUser");

    case LRD_GET_PERMISSIONED_USER.failure:
      ToastError("Error Retrieving User");

      return state;

    case LRD_GET_SETTINGS_USERS.success:
      return defaultReturn(state, payload, "permissionedUsers");

    case LRD_GET_SETTINGS_USERS.failure:
      ToastError("Error Retrieving Users");

      return state;

    case LRD_UPDATE_PERMISSIONED_USERS.success:
      ToastSuccess("User Permissions and Roles Successfully Updated");

      return defaultReturn(state);

    case LRD_UPDATE_PERMISSIONED_USERS.failure:
      ToastError("Updating User Permissions and Roles Failed");

      return defaultReturn(state);

    case LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID.success:
      return defaultReturn(state, payload, "permissionedUsersByCompany");

    case LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID.failure:
      ToastError("Error retrieving permissioned users by Company ID");

      return defaultReturn(state);

    case SET_LRD_STORE.value:
      return defaultReturn({ ...state, ...payload });

    default:
      return state;
  }
};

// SAGA

export const lenderReportingDashboardSaga = function* () {
  yield takeLatest(LRD_GET_LENDER_VIEW_REPORT.value, getLenderViewReportSaga);
  yield takeLatest(LRD_GET_REPORT_GROUPS.value, getReportGroupsSaga);
  yield takeLatest(LRD_GET_SUBMITTED_RGIS.value, getSubmittedRgisSaga);
  yield takeLatest(LRD_GET_RECIPIENTS_CONFIG.value, getRecipientsConfigSaga);
  yield takeLatest(LRD_UPDATE_RECIPIENTS_CONFIG.value, updateRecipientsConfigSaga);
  yield takeLatest(LRD_GET_SHARE_RECORDS.value, getShareRecordsSaga);
  yield takeLatest(LRD_CREATE_SHARE_RECORD.value, createShareRecordSaga);
  yield takeLatest(LRD_CREATE_SHARE_RECORDS.value, createShareRecordsSaga);
  yield takeLatest(LRD_UPDATE_SHARE_RECORDS.value, updateShareRecordsSaga);
  yield takeLatest(LRD_GET_INSTANCE_DETAILS.value, getInstanceDetailsSaga);
  yield takeLatest(LRD_UPDATE_INSTANCE_DETAILS.value, updateInstanceDetailsSaga);
  yield takeLatest(LRD_DELETE_REPORT_GROUP_INSTANCE.value, deleteReportGroupInstanceSaga);
  yield takeLatest(LRD_GET_CONFIG_ITEMS.value, getReportingConfigItemsSaga);

  yield takeLatest(LRD_GET_NOTES.value, getNotesSaga);
  yield takeLatest(LRD_PUT_NOTE.value, putNoteSaga);
  yield takeLatest(LRD_POST_NOTE.value, postNoteSaga);
  yield takeLatest(LRD_DELETE_NOTE.value, deleteNoteSaga);

  yield takeLatest(LRD_GET_ATTACHMENTS.value, getAttachmentsSaga);
  yield takeLatest(LRD_PUT_ATTACHMENT.value, putAttachmentSaga);
  yield takeLatest(LRD_POST_ATTACHMENT.value, postAttachmentSaga);
  yield takeLatest(LRD_DELETE_ATTACHMENT.value, deleteAttachmentSaga);
  yield takeLatest(LRD_UPDATE_TASKS.value, updateTasksSaga);
  yield takeLatest(LRD_ADD_TASK.value, addTaskSaga);
  yield takeLatest(LRD_UPDATE_AUTH_RECORD.value, updateAuthRecordSaga);
  yield takeLatest(LRD_MARK_AUTH_EXTERNAL.value, markAuthExternalSaga);
  yield takeLatest(LRD_MARK_AUTH_EMAIL.value, markAuthEmailSaga);

  yield takeLatest(LRD_GET_PERMISSIONED_USER.value, getPermissionedUserSaga);
  yield takeLatest(LRD_GET_SETTINGS_USERS.value, getPermissionedUsersSaga);
  yield takeLatest(LRD_UPDATE_PERMISSIONED_USERS.value, updatePermissionedUsersSaga);
  yield takeLatest(LRD_GET_PERMISSIONED_USERS_BY_COMPANY_ID.value, getPermissionedUserByCompanyIdSaga);
  yield takeLatest(LRD_DOWNLOAD_REPORT.value, downloadReportSaga);
  yield takeLatest(LRD_LENDER_DOWNLOAD_REPORT.value, downloadLenderReportSaga);
};
